import { actionTypes } from "../actions/plans";

const variable = (state = null, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PLAN:
      return action.payload;
    default:
      return state;
  }
};

export default variable;